import {SNACKBAR_ACTIONS} from "./types";

export const SNACKBAR_TYPE_DEFAULT = null;
export const SNACKBAR_TYPE_ALERT = 'alert';
export const showSnackbar = (message = null, color = SNACKBAR_TYPE_DEFAULT) => ({type: null === message ? SNACKBAR_ACTIONS.UNSET : SNACKBAR_ACTIONS.SET, message, color});
export const hideSnackbar = () => showSnackbar();



// WEBPACK FOOTER //
// ./src/actions/snachbarActions.js